var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3863 1.78647C11.2796 1.86647 11.1996 3.14647 11.1996 4.61314V7.2798L9.25294 9.57314C3.06628 16.8798 1.59961 18.7198 1.59961 19.1998C1.59961 19.4931 1.83961 19.9731 2.13294 20.2665C2.63961 20.7731 3.01294 20.7998 11.9996 20.7998C20.9863 20.7998 21.3596 20.7731 21.8663 20.2665C22.9329 19.1998 23.0129 19.3331 14.7463 9.57314C13.1196 7.6798 12.7996 7.1198 12.7996 6.34647C12.7996 5.4398 12.8529 5.38647 14.4796 4.7998C16.1863 4.1598 16.7996 3.81314 16.7996 3.46647C16.7996 3.2798 12.3729 1.5998 11.8396 1.5998C11.6796 1.5998 11.4663 1.6798 11.3863 1.78647ZM14.2396 11.4398C15.3596 12.7465 16.2663 13.8931 16.2663 13.9731C16.2663 14.0798 15.6529 13.8398 14.9329 13.4665C13.6796 12.8265 13.5463 12.8265 12.7996 13.1998C12.0263 13.5998 11.9996 13.5998 11.5996 12.7998L11.1729 11.9998L9.83961 12.6931C9.09294 13.0665 8.42628 13.3331 8.39961 13.2798C8.26628 13.1465 11.7596 9.06647 11.9996 9.06647C12.1063 9.06647 13.1196 10.1331 14.2396 11.4398Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneIcon);
export default __webpack_public_path__ + "static/media/MilestoneIcon.36484045eca112a0f5d4ac6500b3e01a.svg";
export { ForwardRef as ReactComponent };